import React from 'react'

const DoxCheckMark = () => (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.00039 11.2L1.80039 6.99998L0.400391 8.39998L6.00039 14L18.0004 1.99998L16.6004 0.599976L6.00039 11.2Z" fill="#14AA40" />
    </svg>
)

export default DoxCheckMark